import React, { useRef, FC } from "react"

import { generateConditionalClassName } from "@utils"

import "./Tabs.scss"

export type TabsProps = {
  activeOption?: string | number | null
  onClickOption?: (value: string | number) => void
  options: {
    mobileTitle?: string | null
    title: string | null
    url?: string | null
    value: string | number | null
  }[]
  useSpaceEvenly?: boolean | null
}

const Tabs: FC<TabsProps> = ({
  activeOption = null,
  onClickOption,
  options = [],
  useSpaceEvenly,
}) => {
  const WrapperRef = useRef<HTMLDivElement | null>(null)

  const _classNameTabsDiv = generateConditionalClassName({
    "Tabs--Items": true,
    "use-equal-width": Boolean(useSpaceEvenly),
    [`options-${options.length}`]: Boolean(options.length),
  })

  return (
    <div className="Tabs" ref={WrapperRef}>
      <div className={_classNameTabsDiv}>
        {options.map((option) => {
          const _className = generateConditionalClassName({
            "Tabs--Option": true,
            "font--text-S": true,
            "is-active": activeOption === option.value,
          })
          const content = (
            <>
              {option.mobileTitle ? (
                <>
                  <span className="mobile">
                    {option.mobileTitle}
                  </span>
                  <span className="desktop">{option.title}</span>
                </>
              ) : (
                option.title
              )}
            </>
          )
          return option.url ? (
            <a
              className={_className}
              href={option.url}
              key={option.value}
            >
              {content}
            </a>
          ) : (
            <button
              className={_className}
              key={option.value}
              onClick={
                onClickOption ?
                  () => onClickOption(option.value || "") :
                  undefined
              }
            >
              {content}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default Tabs
